import React from 'react';
import EvaluatorPaymentItem from '../../../../Domain/EvaluatorPaymentItem';
import CurrencyNoteTextsEnum from '../../../../Enums/CurrencyNoteTextsEnum';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import EvaluatorPaymentService from '../../../../Services/EvaluatorPaymentService';
import selectHelper from '../../../../Helpers/selectHelper';

export default class EditAdvancePaymentWindowDescription extends React.Component {
  static titleForCreate = 'New Advance Payment';
  static titleForEdit = 'Edit Advance Payment';
  static itemType = EvaluatorPaymentItem;
  static serviceFunction = (edited) => EvaluatorPaymentService.UpsertEvaluatorPayment(edited);

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'EvaluatorCurrencyId',
          label: 'Currency',
          tooltipText: CurrencyNoteTextsEnum.AdvancePayment,
          type: InputTypesEnum.CurrencySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'IeReimbursement',
          label: 'Reimbursement',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
        {
          fieldName: 'IePaymentTypeName',
          label: 'Payment Method',
          type: InputTypesEnum.Select,
          validityChecker: ValidityHelper.AlwaysFlawless,
          selectvalues: EditAdvancePaymentWindowDescription.getPaymentMethods(),
        },
        {
          fieldName: 'IeComment',
          label: 'Comment',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];

  static getCurrency(item) {
    return `${item.IeRcyName} (${item.IeRcysymbol})`;
  }

  static getPaymentMethods() {
    return selectHelper.generateSelectValues(['Check', 'International', 'Tipalti']);
  }
}
